module.exports = __webpack_public_path__ + "static/platypus_square-ff327beb12adcc71bb78c44b8d18fed9.jpg";